function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-bottom: 2rem;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  /* prose 스타일 - 마크다운 컨텐츠를 위한 기본 스타일 */\n  max-width: none;\n  color: ",
        ";\n  \n  h1, h2, h3, h4, h5, h6 {\n    margin-top: 1.5rem;\n    margin-bottom: 0.75rem;\n    font-weight: 600;\n  }\n  \n  h1 { font-size: 2rem; }\n  h2 { font-size: 1.5rem; }\n  h3 { font-size: 1.25rem; }\n  \n  p {\n    margin-bottom: 1rem;\n    line-height: 1.75;\n  }\n  \n  ul, ol {\n    margin-bottom: 1rem;\n    padding-left: 1.5rem;\n  }\n  \n  li {\n    margin-bottom: 0.5rem;\n  }\n  \n  code {\n    background-color: ",
        ";\n    padding: 0.125rem 0.25rem;\n    border-radius: 0.25rem;\n    font-size: 0.875rem;\n  }\n  \n  pre {\n    background-color: ",
        ";\n    padding: 1rem;\n    border-radius: 0.5rem;\n    overflow-x: auto;\n    margin-bottom: 1rem;\n  }\n  \n  blockquote {\n    border-left: 4px solid ",
        ";\n    padding-left: 1rem;\n    margin-left: 0;\n    margin-bottom: 1rem;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
var ContentContainer = styled.div(_templateObject());
var ProseWrapper = styled.div(_templateObject1(), function(props) {
    return props.theme.text;
}, function(props) {
    return props.theme.isDark ? '#374151' : '#f3f4f6';
}, function(props) {
    return props.theme.isDark ? '#1f2937' : '#f9fafb';
}, function(props) {
    return props.theme.border;
}, function(props) {
    return props.theme.textSecondary;
});
export var ProjectContent = function(param) {
    var content = param.content;
    return /*#__PURE__*/ React.createElement(ContentContainer, null, /*#__PURE__*/ React.createElement(ProseWrapper, null, content));
};
export default ProjectContent;
